import React from "react";
import axios from "axios";
import lodash from "lodash";

import List from "./List";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

const Header = () => (
  <thead>
    <tr>
      <th></th>
      <th>Title</th>
      <th>Location(s)</th>
      <th />
    </tr>
  </thead>
);

class ListForms extends React.Component {
  state = {
    forms: [],
    loading: true
  };

  componentWillMount() {
    axios.get(
      "/custom_forms.json", {
        params: { for_admin_dashboard: true }
      }
    ).then(resp => {
      this.setState({
        forms: resp.data.custom_forms,
        loading: false
      });
    });
  }

  render() {
    const { loading, forms } = this.state;

    return (
      <div>
        <div>
          <div className="row">
            <div className="col-xs-6">
              <a className="btn btn-text" href="/custom_forms/access_editor">
                EDIT FORMS ACCESS
              </a>
            </div>
            <div className="col-xs-6">
              <div className="pull-right">
                <a className="btn btn-text" href="/custom_forms/new">
                  ADD CUSTOM FORM
                </a>
              </div>
            </div>
          </div>
          <hr />

          {loading || forms.length === 0 ? (
            <span>
              <br />
              <p className="grey-text">{loading ? "Loading..." : "No Forms"}</p>
            </span>
          ) : (
            <DragDropContext onDragEnd={this.handleSort}>
              <table className="table table-clean ng-scope">
                <Header />

                <Droppable droppableId="table">
                  {droppableProvided => (
                    <tbody
                      ref={ref => { droppableProvided.innerRef(ref); }}
                      { ...droppableProvided.droppableProps }
                    >
                      <List
                        customForms={forms}
                        onDelete={this.handlerDelete}
                        onDuplicate={this.handlerDuplicate}
                        onCopy={this.handlerCopyURL}
                      />
                    </tbody>
                  )}
                </Droppable>
              </table>
            </DragDropContext>
          )}
        </div>
      </div>
    );
  }

  reorder = (list, startIndex, endIndex) => {
    let result = Array.from(list) // create a new object for this.state.forms array
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    result = result.map((item, index) => {
      item.sort_order = index;
      return item;
    });

    return result;
  }

  updateOrder = () => {
    const data = this.state.forms.map((form) => (
      { id: form.id, sort_order: form.sort_order }
    ));

    axios.post(
      '/custom_forms/update_sort_order', { data }
    ).then(() => {
      toastr.success('Custom Form sort order updated')
    }).catch((error) => {
      toastr.error('Something went wrong');
      console.log('UpdateOrder:error', error)
    })
  }

  handleSort = (result) => {
    if (!result.destination) return;
    if (result.destination.index === result.source.index) return;

    const forms = this.reorder(this.state.forms, result.source.index, result.destination.index);

    this.setState({ forms }, this.updateOrder);
  }

  handlerDelete = id => {
    if (!confirm("Are you sure you want to delete this form?")) {
      return;
    }

    const tmp = this.state.forms;
    const idx = lodash.findIndex(tmp, { id: id });

    if (idx !== -1) {
      tmp.splice(idx, 1);
      this.setState({ forms: tmp });
    }

    toastr.error("Custom Form deleted");

    axios.delete(`/custom_forms/${id}.json`);
  };

  handlerDuplicate = id => {
    if (!confirm("Are you sure you want to duplicate this custom form?")) {
      return;
    }

    axios
      .get("/schedule_duplicate_custom_form", {
        params: {
          custom_form_id: id
        }
      })
      .then(function(response) {
        toastr.success(
          "CustomForm has been duplicated, please check your email for confirmation"
        );
        setTimeout(
          function() {
            Turbolinks.visit("/admin_dashboard/");
          }.bind(this),
          1000
        );
      })
      .catch(function(error) {
        toastr.error("CustomForm not duplicated");
        console.log(error);
      });
  };

  handlerCopyURL = (customForm) => {
    toastr.info('Custom Form Public URL copied to clipboard')
    navigator.clipboard.writeText(customForm.public_url)
  }
}

export default ListForms;
